import React, { useState, useEffect } from "react";
import { Icon, Row, Col, Button, Statistic, Progress} from "antd";
import moment from "moment";
import useInterval from '../../hooks/useInterval';
import { secons2text } from "../../services/timeFunctions";
import { Wrapper, H3 } from "./styles";
import Table from "../../components/table";
import Search from "../../components/table/search";
import useManufacturingOrder from '../../hooks/useManufacturingOrder';
import { useTranslation } from 'react-i18next';
import { marksAgitation } from "../../constants";

const RenderQuenching = ({quenchingStatus}) => {
  const [litrosSegundos] = useState(2);
  const [tiempoEstado] = useState(50);
  const [tipoBaño] = useState("water");
  const [manufacturingList, setManufacturingList] = useState(null);
  const [quenchingArticle, setQuenchingArticle] = useState(null);
  const [furnaceArticle, setFurnaceArticle] = useState(null);
  const [setFurnaceNowTemperature] = useState(750);
  const { manufacturingOrder, updateData } = useManufacturingOrder();
  const { t } = useTranslation();

  useInterval(() => {
    setQuenchingArticle([...quenchingArticle]);
  }, 1000);


  useEffect(()=>{
    let temp = localStorage.getItem('furnaceTemp');
    if (temp) setFurnaceNowTemperature(parseInt(temp));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  useEffect(() => {
    const filtered = manufacturingOrder.filter((order, i) => order.desing);
    const normalized = filtered.map((order, i) => {
      return {
        key: i,
        ...order
      };
    });

    const quenchingList = [];
    const intoFurnaceList = [];
    filtered.forEach((order, i) => {
      order.pieces.forEach((piece, x) => {
        let a = {
          key: "que-"+x+"-"+piece.id,
          ...piece,
          ref: order.ref,
          furnace: order.desing.furnace,
          furnaceTime: piece.furnace,
          timeFurnace: 50,
          timeQuenching: 50,
          quenching: order.desing.quenching,
          quenchingTime: piece.quenching,
          tempered: order.desing.quenching
        };
        if(piece.quenching && piece.quenching.start && !piece.quenching.end) quenchingList.push(a);
        if(piece.furnace && piece.furnace.start && !piece.furnace.end) intoFurnaceList.push(a);
      });
    });

    setQuenchingArticle(quenchingList);
    setFurnaceArticle(intoFurnaceList);

    normalized && setManufacturingList(normalized);
  }, [manufacturingOrder]);

  const columnsOrders = [
    {
      title: t('table.header.ref'),
      dataIndex: "ref",
      key: "ref",
      sorter: (a, b) => a.ref.localeCompare(b.ref),
      defaultSortOrder: "descend"
    },
    {
      title: t('table.header.article'),
      dataIndex: "article.articleName",
      key: "article.articleName"
    },
    {
      title: t('table.header.percent_pieces_quenching'),
      dataIndex: "pieces",
      key: "pieces",
      render: (text, record) => {
        if(!record.pieces) return;
        let ended = record.pieces.reduce((total,x) => (x.quenching && x.quenching.end ? total+1 : total), 0);
        let percent = 100*ended/record.pieces.length;
        
        return (
          <div style={{ width: "100%" }}>
              <Progress percent={percent} size="small" />
          </div>
        )
      }
    }
  ];

  const columnsAvailable = [
    {
      title: t('table.header.ref'),
      dataIndex: "ref",
      key: "ref",
      sorter: (a, b) => a.ref.localeCompare(b.ref),
      defaultSortOrder: "descend",
      ...Search("ref")
    },
    {
      title: t('table.header.number'),
      dataIndex: "id",
      key: "id"
    },
    {
      title: t('table.header.entry_date'),
      dataIndex: "quenchingTime.start",
      key: "quenchingTime.start",
      render: value => value.format("DD/MM/YYYY HH:mm:ss")
    },
    {
      title: t('table.header.exit_date'),
      dataIndex: "timeQuenching",
      key: "timeQuenching",
      render: (timeQuenching, record) => {
        let start = record.quenchingTime.start;
        let sec = start.unix();
        return moment((sec+timeQuenching)*1000).format("DD/MM/YYYY HH:mm:ss")
      }
    },
    {
      title: t('table.header.time'),
      dataIndex: "quenchingTime",
      key: "quenchingTime",
      render: (quenchingTime, record) => {
        let start_sec = quenchingTime.start.unix();
        let plusTime = (quenchingTime.plusTime) ? quenchingTime.plusTime : 0; 
        let this_sec = moment().unix();
        let num = this_sec-start_sec;
        return <h3>{secons2text(num+plusTime)}</h3>
      }
    },
    {
      title: t('table.header.action'),
      dataIndex: "furnace",
      key: "furnace",
      render: (text, record) => {
        return (
          <div>
            <Button 
              type="link" 
              size="small" 
              onClick={() => article2out(record.id, record.ref)}
            >
              {t('button.action.take')}
              <Icon type="right" />
            </Button>
          </div>
        )
      }
    }
  ];

  const columnsFurnace = [
    {
      title: t('table.header.ref'),
      dataIndex: "ref",
      key: "ref",
      sorter: (a, b) => a.ref.localeCompare(b.ref),
      defaultSortOrder: "descend"
    },
    {
      title: t('table.header.number'),
      dataIndex: "id",
      key: "id"
    },
    {
      title: t('table.header.entry_date'),
      dataIndex: "furnaceTime.start",
      key: "furnaceTime.start",
      render: value => value.format("DD/MM/YYYY HH:mm:ss")
    },
    {
      title: t('table.header.agitation'),
      dataIndex: "quenching.caudal",
      key: "quenching.caudal"
    },
    {
      title: t('labels.state.quenching_type'),
      dataIndex: "quenching.bath_type",
      key: "quenching.bath_type",
      render: value => t('labels.quenching.bath_type.'+value)
    },
    {
      title: t('table.header.remaining_time'),
      dataIndex: "timeFurnace",
      key: "timeFurnace",
      render: (timeFurnace, record) => {
        let start_sec = record.furnaceTime.start.unix();
        let end_sec = start_sec+timeFurnace;
        let plusTime = (record.furnaceTime.plusTime) ? record.furnaceTime.plusTime : 0; 
        let this_sec = moment().unix() + plusTime;
        let difference = end_sec-this_sec;
        let negative = difference < 0;
        return (negative) ?  <h3 style={{color: "red"}}>{"- " + secons2text(-1*difference)}</h3> : <h3>{secons2text(difference)}</h3>;
      }
    },
  ];

  const article2out = (id, ref) => {
    let order = manufacturingOrder.find(obj => obj.ref === ref)
    let list = order.pieces.map(obj => {
      if (obj.id === id) {
        return {
          ...obj,
          quenching: {
            ...obj.quenching,
            end: moment()
          },
          quality:{
            start:moment()
          }
        }
      }else return obj
    })
    order.pieces = list;
    updateData(order)
  }

  const timeRunQuenching = (seconds) => {
    manufacturingOrder.forEach((order) => {
      if(order.making) {
        let list = order.pieces.map(obj => {
          if( obj.quenching && obj.quenching.start && !obj.quenching.end) {
            
            let plusTime = (obj.quenching.plusTime) ? obj.quenching.plusTime : 0;
            return {
              ...obj,
              quenching: {
                ...obj.quenching,
                plusTime: plusTime + seconds
              }
            }
            
          }else return obj;
        });
        order.pieces = list;
        updateData(order)
      }
    });
    
  }

  return (
    <Wrapper>
        <Row style={{ margin: 0 }} gutter={[16, 16]}>
            <Col xl={10} lg={10} md={24}>
                <H3>{t('headers.control_process.pieces_in_furnace', {value: furnaceArticle && furnaceArticle.length})}</H3>
                <Table data={furnaceArticle} columns={columnsFurnace} pagination={{ pageSize: 5 }}/>
            </Col>
            <Col xl={2} lg={4} md={24} style={{height: "calc(70vh)"}}>
                <H3>{t('headers.control_process.status')}</H3>
                <Col span={24}>
                  <Statistic
                    title={t('labels.state.quenching_type')}
                    value={t('labels.quenching.bath_type.'+tipoBaño)}
                    style={{textAlign: "center"}}
                  />
                </Col>
                <Col span={24}>
                  <Statistic
                    title={t('labels.state.agitation_level')}
                    value={quenchingStatus && quenchingStatus.agitation_level && marksAgitation[quenchingStatus.agitation_level]}
                    precision={2}
                    suffix="m/s"
                    style={{textAlign: "center"}}
                  />
                </Col>
                <Col span={24}>
                  <Statistic
                    title={t('datos.tempMedio')}
                    value={tiempoEstado}
                    precision={0}
                    suffix="ºC"
                    style={{textAlign: "center"}}
                  />
              </Col>
            </Col>
            <Col xl={12} lg={10} md={24} style={{marginBottom:10}}>
              <Row>
                <Col span={8}> 
                </Col>
                <Col span={8}> 
                  <H3>{t('headers.control_process.pieces_in_quenching', {value: quenchingArticle && quenchingArticle.length})}</H3>
                </Col>
                <Col span={8}> 
                  <Button 
                    type="link" 
                    size="small" 
                    style={{float: "right"}}
                    onClick={() => timeRunQuenching(10)}
                  >
                    <Icon type="clock-circle" />
                    {t('button.advance_time', {time: 10})}
                  </Button>
                </Col>
              </Row>
              <Table data={quenchingArticle} columns={columnsAvailable}  pagination={{ pageSize: 5 }}/>
            </Col>
            <Col xl={12} lg={24} md={24}>
              <H3>{t('headers.control_process.manufacturing_order')}</H3>
              <Table data={manufacturingList} columns={columnsOrders} pagination={{ pageSize: 4 }} />
            </Col>
        </Row>
    </Wrapper>
  );
};
export default RenderQuenching;
